import React, { memo } from "react";
import { TierColorMappings } from "../../../utils";

const CustomChipStyle = (level = 1) => ({
  backgroundColor: TierColorMappings[level],
  fontSize: "10px",
  borderRadius: "2px",
  fontWeight: 600,
  width: " 13px",
  height: "13px",
  color: "#000000",
});

const CustomTierChip = ({ tier }) => {
  return !tier ? (
    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
  ) : (
    <span style={CustomChipStyle(tier)}>T{tier}</span>
  );
};

export default memo(CustomTierChip);
